import { Select, Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef, useState } from 'react';
import './waterOilTable.css';
import { useSelected } from '../../../providers/selectedContext';
import { GenerateColumns, getWaterOilData } from './utils';
import { AnalyzeType } from '../../../@types/samples/types';
import { convertUnit } from '../../../api/data';
import { Zone } from '../../../@types/projects/types';

const unitDepthOptions = [
  { value: 'm' as const, label: 'm' },
  { value: 'ft' as const, label: 'ft' }
];
const unitPressureOptions = [
  { value: 'psi' as const, label: 'psi' },
  { value: 'bar' as const, label: 'bar' }
];

const WaterOilTable = ({ showScaledKr, analysisType, zones }: { showScaledKr: boolean; analysisType: AnalyzeType; zones: Zone[] }) => {
  const { selectedInfo, setSelectedInfo } = useSelected();
  const project = selectedInfo.project;

  const data = getWaterOilData(zones, analysisType, showScaledKr);
  
  const [showTable, setShowTable] = useState(true);
  const [depthUnit, setDepthUnit] = useState<'m' | 'ft'>('ft');
  const [pressureUnit, setPressureUnit] = useState<'psi' | 'bar'>('psi');
  const didInitializeUnits = useRef(false);

  const columns = GenerateColumns(
    zones,
    showScaledKr,
    depthUnit,
    pressureUnit,
  );

  useEffect(() => {
    if (!project?.uid) return;

    if (!didInitializeUnits.current) {
      didInitializeUnits.current = true;
      return;
    }

    convertUnit(
      {
        user: project.users[0],
        project_uid: project.uid,
        depth_unit: depthUnit,
        pressure_unit: pressureUnit
      },
      project.uid
    )
      .then((updatedProject) => {
        setSelectedInfo({
          ...selectedInfo,
          project: updatedProject
        });
      })
      .catch(console.error);
  }, [depthUnit, pressureUnit, project?.uid]);

  return (
    <div style={{ marginTop: '2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <p style={{ fontWeight: 'bold', fontSize: '18px', marginRight: 'auto' }}>
          Water-Oil System Saturation Functions
        </p>
        {/* controles de unidade */}
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <span>Depth Unit:</span>
          <Select
            value={depthUnit}
            options={unitDepthOptions}
            onChange={setDepthUnit}
            size="small"
            style={{ width: 70 }}
          />
          <span>Pressure Unit:</span>
          <Select
            value={pressureUnit}
            options={unitPressureOptions}
            onChange={setPressureUnit}
            size="small"
            style={{ width: 70 }}
          />
        </div>
        <div
          style={{ cursor: 'pointer', marginLeft: '1rem' }}
          onClick={() => setShowTable(!showTable)}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              fontSize: '1.3rem',
              marginTop: '0.3rem',
              marginLeft: '1rem',
              transform: `rotate(${showTable ? '0deg' : '180deg'})`,
              transition: 'transform 0.4s ease'
            }}
          />
        </div>
      </div>
      <div
        className={`water-oil-table-container ${showTable ? 'expanded' : 'collapsed'}`}
      >
        <Table
          dataSource={data}
          columns={columns}
          scroll={{ x: 1500, y: 500 }}
          pagination={false}
          bordered
          size="small"
        />
      </div>
    </div>
  );
};

export default WaterOilTable;
